export default __webpack_public_path__ + "static/Democratica-0421054ad2c6080c91b9c0282cf0e199.woff";